import { Controller } from '@hotwired/stimulus'
import { Turbo } from '@hotwired/turbo-rails'

// Makes a whole card behave like its primary link without an overlay element,
// so hover tooltips inside the card (impact meter, avatar) keep working and
// text stays selectable. Clicks that land on their own interactive element, or
// that finish a text selection, are left alone.
export default class extends Controller {
  static values = { url: String }

  navigate (event) {
    if (event.target.closest('a, button, input, select, label, [role="menu"]')) return
    if (window.getSelection().toString().length > 0) return

    // Match a link's modifier behaviour: open in a new tab rather than here.
    if (event.metaKey || event.ctrlKey || event.shiftKey) {
      window.open(this.urlValue, '_blank')
      return
    }

    Turbo.visit(this.urlValue)
  }
}
